/* ------------------------------------------------------------------
   HORANDO 22.09.2026 - Boost-Analytics fuer die eigene Suche.

   Such-Overlay, Suchergebnisseite und Kollektionsfilter fragen Boost
   direkt ueber die API ab (boost-search-client.js). Die Boost-App-
   Einbettungen sind aus - damit hat Boost bisher nie erfahren, welche
   Uhr nach einer Suche angeklickt oder in den Warenkorb gelegt wurde.
   Performance-Ranking, Personalisierung, Suchauswertung und die
   Klaviyo-Ereignisse von Boost liefen deshalb ohne Daten.

   Ablauf:
   1. Jede Boost-Antwort (suggest / search / filter) wird mitgelesen:
      Request-ID (meta.rid), Suchbegriff bzw. Kollektion und die
      gelieferten Produkte werden kurz in der Sitzung gemerkt.
   2. Klickt der Kunde eine dieser Uhren an, wird der Klick vorgemerkt.
   3. Auf der Produktseite geht "view_product" an Boost, beim Legen in
      den Warenkorb "add_to_cart" mit Cart-Token (Umsatzzuordnung).

   Gesendet wird nur mit Einwilligung (Shopify Customer Privacy API,
   Analyse). Die Suche selbst wird dadurch nicht veraendert - faellt
   hier etwas aus, laeuft sie unveraendert weiter.
   Doku: support.boostcommerce.net, Artikel 10004432

   22.09.2026 (2): Klicks im Header-Overlay werden jetzt erkannt - die
   Uhren sind dort keine Links, sondern Kacheln mit Weiterleitung.
   ------------------------------------------------------------------ */
(function () {
  'use strict'

  if (window.__hdBoostTracking) return
  window.__hdBoostTracking = true

  var ENDPOINT = 'https://lambda.mybcapps.com/e'
  var BOOST_HOST = 'services.mybcapps.com'
  var RESULTS_KEY = 'hdBoostResults'
  var CLICK_KEY = 'hdBoostClick'
  var ATTR_KEY = 'hdBoostAttribution'
  var SESSION_KEY = 'boostSdSessionId'
  var MAX_RESULTS = 300
  var CLICK_TTL = 30 * 60 * 1000
  var ATTR_TTL = 24 * 60 * 60 * 1000

  /* ---------- Hilfen ---------- */

  function readJson(storage, key) {
    try { return JSON.parse(storage.getItem(key) || 'null') } catch (e) { return null }
  }

  function writeJson(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)) } catch (e) { /* voll oder gesperrt */ }
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID()
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  }

  function shopDomain() {
    return (window.Shopify && window.Shopify.shop) || ''
  }

  function handleFromUrl(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/)
    return m ? decodeURIComponent(m[1]).toLowerCase() : ''
  }

  function now() { return Date.now() }

  /* ---------- Einwilligung ---------- */

  var consentQueue = []

  function analyticsAllowed() {
    var cp = window.Shopify && window.Shopify.customerPrivacy
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null
    try { return !!cp.analyticsProcessingAllowed() } catch (e) { return null }
  }

  function loadPrivacyApi() {
    if (window.Shopify && window.Shopify.customerPrivacy) return
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { flushQueue() })
      } catch (e) { /* ohne API wird nichts gesendet */ }
    }
  }

  function flushQueue() {
    if (analyticsAllowed() !== true) return
    var items = consentQueue.splice(0)
    items.forEach(function (payload) { post(payload) })
  }

  document.addEventListener('visitorConsentCollected', flushQueue)

  /* ---------- Senden ---------- */

  function sessionId() {
    var sid = null
    try { sid = window.localStorage.getItem(SESSION_KEY) } catch (e) { sid = null }
    if (!sid) {
      sid = uuid()
      try { window.localStorage.setItem(SESSION_KEY, sid) } catch (e) { /* egal */ }
    }
    return sid
  }

  function customerId() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
    var id = meta && meta.page && meta.page.customerId
    return id ? String(id) : undefined
  }

  function post(payload) {
    payload.sid = sessionId()
    if (!payload.cid) payload.cid = customerId()
    try {
      nativeFetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit'
      }).catch(function () { /* Analytics darf nie stoeren */ })
    } catch (e) { /* egal */ }
  }

  function send(userAction, source, extra) {
    var payload = {
      tid: shopDomain(),
      eid: uuid(),
      rid: source.rid,
      qs: source.qs,
      pid: source.pid,
      a: source.a,
      u: userAction,
      t: new Date().toISOString(),
      r: document.referrer || undefined,
      pg: 'product'
    }
    Object.keys(extra || {}).forEach(function (k) { payload[k] = extra[k] })
    if (!payload.tid || !payload.pid) return

    var allowed = analyticsAllowed()
    if (allowed === true) return post(payload)
    if (allowed === null) { consentQueue.push(payload); loadPrivacyApi() }
    // allowed === false: keine Einwilligung, nichts senden
  }

  /* ---------- 1. Boost-Antworten mitlesen ---------- */

  var nativeFetch = window.fetch.bind(window)

  function actionFor(url) {
    var path = url.pathname
    if (/\/search\/suggest/.test(path)) return 'suggest'
    if (/\/search$/.test(path)) return 'search'
    if (url.searchParams.get('query') || url.searchParams.get('q')) return 'search'
    return 'filter'
  }

  function queryStringFor(url) {
    var q = url.searchParams.get('q') || url.searchParams.get('query')
    if (q) return 'q=' + encodeURIComponent(q)
    var scope = url.searchParams.get('collection_scope')
    if (scope) return 'collection_scope=' + encodeURIComponent(scope)
    return undefined
  }

  function rememberResults(url, data) {
    if (!data || !Array.isArray(data.products) || !data.products.length) return
    var rid = data.meta && data.meta.rid
    if (!rid) return
    var entry = { rid: rid, a: actionFor(url), qs: queryStringFor(url), t: now() }
    var store = readJson(window.sessionStorage, RESULTS_KEY) || {}
    data.products.forEach(function (p) {
      if (!p || !p.handle || !p.id) return
      store[String(p.handle).toLowerCase()] = { pid: String(p.id), rid: entry.rid, a: entry.a, qs: entry.qs, t: entry.t }
    })
    var keys = Object.keys(store)
    if (keys.length > MAX_RESULTS) {
      keys.sort(function (x, y) { return store[x].t - store[y].t })
      keys.slice(0, keys.length - MAX_RESULTS).forEach(function (k) { delete store[k] })
    }
    writeJson(window.sessionStorage, RESULTS_KEY, store)
  }

  function isCartAdd(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || ''
    var method = (init && init.method) || (input && input.method) || 'GET'
    return /\/cart\/add(\.js)?(\?|$)/.test(url) && String(method).toUpperCase() === 'POST'
  }

  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init)
    try {
      var raw = typeof input === 'string' ? input : (input && input.url) || ''
      if (raw.indexOf(BOOST_HOST) !== -1) {
        var url = new URL(raw, window.location.href)
        promise.then(function (res) {
          if (!res || !res.ok) return
          res.clone().json().then(function (data) { rememberResults(url, data) }).catch(function () {})
        }).catch(function () {})
      } else if (isCartAdd(input, init)) {
        promise.then(function (res) { if (res && res.ok) onCartAdd(init) }).catch(function () {})
      }
    } catch (e) { /* die eigentliche Anfrage laeuft unabhaengig davon */ }
    return promise
  }

  /* ---------- 2. Klick auf eine Boost-Uhr vormerken ---------- */

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null
    if (!target) return

    // Header-Overlay: die Uhren sind dort keine Links, sondern Kacheln
    // (div), die per window.location weiterleiten. Welche Uhr es war,
    // steht erst auf der Produktseite fest - dort wird der Klick
    // aufgeloest (siehe onProductPage).
    if (target.closest('[data-option-type="product"]')) {
      writeJson(window.sessionStorage, CLICK_KEY, { overlay: true, t: now() })
      return
    }

    var link = target.closest('a[href*="/products/"]')
    if (!link) return
    var handle = handleFromUrl(link.getAttribute('href'))
    if (!handle) return
    var store = readJson(window.sessionStorage, RESULTS_KEY) || {}
    var hit = store[handle]
    if (!hit) return
    writeJson(window.sessionStorage, CLICK_KEY, { handle: handle, pid: hit.pid, rid: hit.rid, a: hit.a, qs: hit.qs, t: now() })
  }, true)

  /* ---------- 3a. Produktseite: view_product ---------- */

  function currentProduct() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
    var product = meta && meta.product
    var handle = handleFromUrl(window.location.pathname)
    return handle ? { handle: handle, pid: product && product.id ? String(product.id) : null } : null
  }

  function attributionFor(product) {
    var attr = readJson(window.localStorage, ATTR_KEY) || {}
    var hit = attr[product.handle]
    if (!hit || now() - hit.t > ATTR_TTL) return null
    return hit
  }

  function onProductPage() {
    var product = currentProduct()
    if (!product) return
    var click = readJson(window.sessionStorage, CLICK_KEY)
    if (click && click.overlay && now() - click.t < 60 * 1000) {
      var hit = (readJson(window.sessionStorage, RESULTS_KEY) || {})[product.handle]
      click = hit ? { handle: product.handle, pid: hit.pid, rid: hit.rid, a: hit.a, qs: hit.qs, t: click.t } : null
    }
    if (!click || click.handle !== product.handle || now() - click.t > CLICK_TTL) return
    try { window.sessionStorage.removeItem(CLICK_KEY) } catch (e) {}

    var source = { pid: product.pid || click.pid, rid: click.rid, a: click.a, qs: click.qs }
    send('view_product', source)

    // fuer den Warenkorb auf dieser Seite und bei spaeterer Rueckkehr
    var attr = readJson(window.localStorage, ATTR_KEY) || {}
    attr[product.handle] = { pid: source.pid, rid: source.rid, a: source.a, qs: source.qs, t: now() }
    Object.keys(attr).forEach(function (k) { if (now() - attr[k].t > ATTR_TTL) delete attr[k] })
    writeJson(window.localStorage, ATTR_KEY, attr)
  }

  /* ---------- 3b. Warenkorb: add_to_cart ---------- */

  function variantFrom(init) {
    var body = init && init.body
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var json = JSON.parse(body)
          return String((json.items && json.items[0] && json.items[0].id) || json.id || '')
        }
        return new URLSearchParams(body).get('id') || ''
      }
      if (body && typeof body.get === 'function') return String(body.get('id') || '')
    } catch (e) { /* ohne Variante weiter */ }
    return ''
  }

  function onCartAdd(init) {
    var product = currentProduct()
    if (!product) return
    var source = attributionFor(product)
    if (!source) return
    var vid = variantFrom(init)
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json() })
      .then(function (cart) {
        send('add_to_cart', source, { ct: cart && cart.token ? String(cart.token).split('?')[0] : undefined, vid: vid || undefined })
      })
      .catch(function () { send('add_to_cart', source, { vid: vid || undefined }) })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onProductPage)
  } else {
    onProductPage()
  }
})()
